export function getOrganisationLabel(org) {
  if (!org) return '';
  return org.name || org.organisation_name || org.label || '';
}

export function getOrganisationId(org) {
  return org?.organisation_id ?? org?.id ?? null;
}

export function isSameOrganisation(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;
  return String(getOrganisationId(a)) === String(getOrganisationId(b));
}

export function mapOrganisationToSelectOption(org) {
  if (!org) return null;
  const organisationId = getOrganisationId(org);
  return {
    ...org,
    id: organisationId,
    label: getOrganisationLabel(org),
  };
}
